import React from 'react';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  titleStyle?: React.CSSProperties;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ icon, title, titleStyle }) => (
  <div className="flex items-center">
    <span className="mr-3">{icon}</span>
    <h2 className="text-3xl font-bold text-gray-800" style={titleStyle}>
      {title}
    </h2>
  </div>
);

export default SectionHeader;
